export function formatScheduleTime(raw) {
  if (!raw) {
    return '';
  }

  const text = String(raw);
  if (/^\d{2}:\d{2}/.test(text)) {
    return text.slice(0, 5);
  }

  return '';
}

export function resolveRecordSchedule(medicalRecord, fallbackSchedule = null) {
  if (!medicalRecord?.id_sched) {
    return null;
  }

  if (medicalRecord.schedule) {
    return medicalRecord.schedule;
  }

  if (fallbackSchedule?.id_sched && fallbackSchedule.id_sched === medicalRecord.id_sched) {
    return fallbackSchedule;
  }

  return null;
}

export function medicalRecordHeaderTitle(medicalRecord, fallbackSchedule, formatDate) {
  const dateLabel = formatDate(medicalRecord?.medrec_date_time);
  const schedule = resolveRecordSchedule(medicalRecord, fallbackSchedule);
  const time = formatScheduleTime(schedule?.sched_time);
  const type = medicalRecord?.record_type?.rectype_name || '';
  const specialty = schedule?.specialty?.spec_name || '';

  const dateTime = time ? `${dateLabel} ${time}` : dateLabel;
  const withType = type ? `${dateTime} - ${type}` : dateTime;

  return specialty ? `${withType} · ${specialty}` : withType;
}
